export default __webpack_public_path__ + "static/media/myjourney-greentree-fruit.067b32f0.svg";